import { gql } from '@apollo/client'

export const ROLE_FEATURES_QUERY = gql`
  query RoleFeatures($input: RoleFeaturesInput!) {
    roleFeatures(input: $input) {
      featureGroup
      features {
        featureID
        name
        description
        selected
      }
    }
  }
`

export const FEATURES_QUERY = gql`
  query Features {
    features {
      featureGroup
      features {
        featureID
        name
        description
        selected
      }
    }
  }
`

export const UPDATE_FEATURE_FLAG_MUTATION = gql`
  mutation UpdateFeatureFlag($input: UpdateFeatureFlagInput!) {
    updateFeatureFlag(input: $input) {
      message
    }
  }
`
export const BULK_UPDATE_FEATURE_FLAG_MUTATION = gql`
  mutation BulkUpdateFeatureFlag($input: BulkUpdateFeatureFlagInput!) {
    bulkUpdateFeatureFlag(input: $input) {
      message
    }
  }
`
